var _defs, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsvSourceIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "88.281%",
    x2: "0%",
    y2: "11.719%",
    id: "CsvSourceIcon_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596168",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B99",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 12a2 2 0 011.732 1H408a1 1 0 110 2l-6.268.001a2 2 0 01-3.464 0L394 15a1 1 0 110-2h4.268A2 2 0 01400 12zm5-5a2 2 0 011.732 1H408a1 1 0 110 2l-1.268.001a2 2 0 01-3.464 0L394 10a1 1 0 110-2h9.268A2 2 0 01405 7zm-6-5a2 2 0 011.732 1H408a1 1 0 110 2l-7.268.001a2 2 0 01-3.464 0L394 5a1 1 0 110-2h3.268A2 2 0 01399 2z",
    transform: "translate(-393 -2)",
    fill: "url(#CsvSourceIcon_svg__[object_Object]a)",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvSourceIcon);
export default ForwardRef;